/**
 * Created by commyfeng on 2016/10/26.
 */

import Onview from '@tencent/vft-onview'
import * as reporter from './report'
import lazyreport from '@tencent/txmv-core/monitor/lazyreport'

var _reporter = reporter
/**
 * Vue 上报插件
 * 1、install的时候自动上报pv
 * 2、元素曝光或点击上报指令 v-report,曝光上报加描述符expose,点击上报加描述符hot
 *   指令内容会附加上报的 具体可用内容参数查看 http://beehive.boss.webdev.com/bossid/myid/viewId?id=5322
 *
 * 例子：
 * v-report.expose="{f_hottag:'filmlist_mod',f_module:'VIP大片'}" 曝光上报，并且f_hottag为 mod_film_list
 * v-report.expose="{f_hottag:'filmlist_mod',f_module:'VIP大片',exposedOnce:'filmlist_mod'}" 曝光上报，exposedOnce相同的只上报一次，避免由于v-if导致模块重复上报曝光
 * v-report.hot="{f_hottag:'filmlist_cid_poster',f_cid:item.cid,f_module:'VIP大片'}" 点击上报，并且f_hottag 为 film_list_cid_poster f_cid 为 item.cid
 * v-report.hot.expose="{f_hottag:'filmlist_mod',f_module:'VIP大片'}" 曝光上报，点击上报
 * v-report = "{f_hottag:'filmlist_mod',f_module:'VIP大片'}" 曝光上报，点击上报
 *
 * 为了方便支持f_module的上报，特加以下特性:
 * v-module="{focus:'焦点图'}" 标记对应dom下面的f_module都是 焦点图
 * v-report = "{f_hottag:'$mdoule$'}" $mdoule$ 会被替换成 focus
 */
const REPORT_KEY = 'reportkey'
var _genKey = (function () {
  var index = 0
  return function () {
    return 'key' + (index++)
  }
})()

var exposedOnce = {}

var _ready = false

var _fixParam = function (param = {}) {
  return param
}

var reportArr = []

function toObject (param) {
  if (typeof param === 'string') {
    try {
      param = JSON.parse(param)
    } catch (e) {}
  }
  return param
}

function _click (param) {
  if (!_ready) {
    reportArr.push({
      type: 'click',
      param
    })
  } else {
    _reporter.click(_fixParam({
      ...param,
      f_event: 'click'
    }))
  }
}

function _expose (param) {
  if (!_ready) {
    reportArr.push({
      type: 'expose',
      param
    })
  } else {
    _reporter.expose(_fixParam({
      ...param,
      f_event: 'expose'
    }))
  }
}

export default {

  /**
   * 配置默认reporter的BossId
   * @param PV 如{bossId: 3754, pwd: 598288292}
   * @param EVENT 如{bossId: 3753, pwd: 1449912345}
   */
  configBossId: reporter.configBossId,

  setReporter (reporter) {
    if (reporter.pv && reporter.click && reporter.expose) {
      _reporter = reporter
    }
  },

  // 设置上报补充参数
  setFixParam (fixParam) {
    _fixParam = fixParam
  },

  ready ({
    ignorePV = false
  } = {}) {
    _ready = true
    if (!ignorePV) {
      _reporter.pv(_fixParam())
    }
    for (let i = 0, len = reportArr.length; i < len; i++) {
      const obj = reportArr[i]
      if (obj.type === 'click') {
        _reporter.click(_fixParam(obj.param))
      } else {
        _reporter.expose(_fixParam(obj.param))
      }
    }
    reportArr = [] // m站切换剧集时，没有销毁report，切换后reportArr保留了上次的存储，ready时再次上报
  },

  install (Vue, { reportVip = false, store = null } = {}) {
    lazyreport.report()

    if (reportVip && store) {
      _fixParam = function (params = {}) {
        const payvip = store.state.payVip || store.state.vipInfo
        if (payvip) {
          params.f_vip = payvip.vip ? 1 : 0
          if (params.f_vip) {
            params.f_level = payvip.level
          }
        } else {
          params.f_vip = -1
        }

        return params
      }
    }

    const moduleAttrKey = 'data-module'

    Vue.directive('module', {
      bind: function (el, binding) {
        $(el).attr(moduleAttrKey, JSON.stringify(binding.value))
      },
      update: function (el, binding) {
        $(el).attr(moduleAttrKey, JSON.stringify(binding.value))
      },
      unbind: function (el) {
        $(el).attr(moduleAttrKey, null)
      }
    })

    function addModuleParam (param, el) {
      const moduleEl = $(el).closest(`[${moduleAttrKey}]`)
      if (moduleEl.length > 0) {
        const data = toObject(moduleEl.attr(moduleAttrKey))

        const key = Object.keys(data)[0]
        const desc = data[key]
        for (const i in param) {
          if (typeof param[i] === 'string') { param[i] = param[i].replace('$module$', key) }
        }
        if (typeof param.f_module === 'undefined') {
          param.f_module = desc
        }
      }

      return param
    }

    var unBindExpose = []

    Vue.directive('report', {
      bind: function (el, binding) {
        var isReportAll = !binding.modifiers.click && !binding.modifiers.expose
        var bindValue = Object.assign({}, binding.value)
        binding.modifiers.lazy && delete bindValue.flag
        $(el).data('report', JSON.stringify(bindValue))

        if (isReportAll || binding.modifiers.click || binding.modifiers.hot) {
          el.addEventListener('click', () => {
            // 触发点击事件
            const param = toObject($(el).data('report'))
            addModuleParam(param, el)
            _click(param)
          }, true)
        }

        if (isReportAll || binding.modifiers.expose) {
          const reportKey = _genKey()
          $(el).attr(REPORT_KEY, reportKey)
          if (binding.modifiers.lazy && !binding.value.flag) {
            return
          }
          Vue.nextTick(() => {
            unBindExpose[reportKey] = Onview(el, {
              once: !binding.modifiers.multi
            }, function () {
              const param = toObject($(el).data('report'))
              if (param.exposeOnce) {
                if (exposedOnce[param.exposeOnce]) return
                exposedOnce[param.exposeOnce] = true
              }
              addModuleParam(param, el)
              _expose(param)
            })
          })
        }
      },
      update: function (el, binding) {
        var isReportAll = !binding.modifiers.click && !binding.modifiers.expose
        var bindValue = Object.assign({}, binding.value)
        const reportKey = $(el).attr(REPORT_KEY)
        binding.modifiers.lazy && delete bindValue.flag
        $(el).data('report', JSON.stringify(bindValue))

        if (binding.modifiers.lazy && !binding.value.flag) {
          unBindExpose[reportKey] && unBindExpose[reportKey]()
          delete unBindExpose[reportKey]
        }

        if (isReportAll || binding.modifiers.expose) {
          if (binding.modifiers.lazy && binding.value.flag && !binding.oldValue.flag) {
            Vue.nextTick(() => {
              unBindExpose[reportKey] = Onview(el, {
                once: true
              }, function () {
                const param = toObject($(el).data('report'))
                if (param.exposeOnce) {
                  if (exposedOnce[param.exposeOnce]) return
                  exposedOnce[param.exposeOnce] = true
                }
                addModuleParam(param, el)
                _expose(param)
              })
            })
          }
        }
      },
      unbind: function (el) {
        var reportKey = $(el).attr(REPORT_KEY)
        $(el).off('click').removeAttr(REPORT_KEY)
        unBindExpose[reportKey] && unBindExpose[reportKey]()
        delete unBindExpose[reportKey]
      }
    })

    Vue.prototype.report = {
      click: _click,
      expose: _expose
    }
  }
}
